import React from "react";

function Empty(props) {
  return (
    <div className="col text-center mt-5">
      <img
        alt=""
        width="35"
        src={require("../../assets/icons/empty.svg").default}
      />
      <p className="mt-4 fs-7 text-secondary">{props.text || "موردی یافت نشد."}</p>
    </div>
  );
}

export default Empty;
